// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { TrusteeDropdown_HouseholdFragment } from '../../../inputs/TrusteeDropdown/graphql/TrusteeDropdown.generated';
import { PrimaryClientDropdown_HouseholdWithGrantorsFragment } from '../../../inputs/PrimaryClientDropdown/graphql/PrimaryClientDropdown.generated';
import { gql } from '@apollo/client';
import { TrusteeDropdown_HouseholdFragmentDoc } from '../../../inputs/TrusteeDropdown/graphql/TrusteeDropdown.generated';
import { PrimaryClientDropdown_HouseholdWithGrantorsFragmentDoc } from '../../../inputs/PrimaryClientDropdown/graphql/PrimaryClientDropdown.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NonGrantorPrincipalFieldsFormOptionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type NonGrantorPrincipalFieldsFormOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & TrusteeDropdown_HouseholdFragment
        & PrimaryClientDropdown_HouseholdWithGrantorsFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    NonGrantorPrincipalFieldsFormOptions: 'NonGrantorPrincipalFieldsFormOptions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const NonGrantorPrincipalFieldsFormOptionsDocument = gql`
    query NonGrantorPrincipalFieldsFormOptions($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        ...TrusteeDropdown_Household
        ...PrimaryClientDropdown_HouseholdWithGrantors
      }
    }
  }
}
    ${TrusteeDropdown_HouseholdFragmentDoc}
${PrimaryClientDropdown_HouseholdWithGrantorsFragmentDoc}`;

/**
 * __useNonGrantorPrincipalFieldsFormOptionsQuery__
 *
 * To run a query within a React component, call `useNonGrantorPrincipalFieldsFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonGrantorPrincipalFieldsFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonGrantorPrincipalFieldsFormOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNonGrantorPrincipalFieldsFormOptionsQuery(baseOptions?: Apollo.QueryHookOptions<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>(NonGrantorPrincipalFieldsFormOptionsDocument, withFetchPolicyContext(options));
      }
export function useNonGrantorPrincipalFieldsFormOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>(NonGrantorPrincipalFieldsFormOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useNonGrantorPrincipalFieldsFormOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>(NonGrantorPrincipalFieldsFormOptionsDocument, withFetchPolicyContext(options));
        }
export type NonGrantorPrincipalFieldsFormOptionsQueryHookResult = ReturnType<typeof useNonGrantorPrincipalFieldsFormOptionsQuery>;
export type NonGrantorPrincipalFieldsFormOptionsLazyQueryHookResult = ReturnType<typeof useNonGrantorPrincipalFieldsFormOptionsLazyQuery>;
export type NonGrantorPrincipalFieldsFormOptionsSuspenseQueryHookResult = ReturnType<typeof useNonGrantorPrincipalFieldsFormOptionsSuspenseQuery>;
export type NonGrantorPrincipalFieldsFormOptionsQueryResult = Apollo.QueryResult<NonGrantorPrincipalFieldsFormOptionsQuery, NonGrantorPrincipalFieldsFormOptionsQueryVariables>;